import axiosInstance from './axiosConfig';


// ads_analyses record getting here
export const adsAnalyse = async ({ formattedEnd , formattedStart , selectedIds , selectedTab }) => {
  const { productId = [], categoryId = [] , parentProductId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const parentProductIdStr = parentProductId.join(',');
  const viewType = localStorage.getItem("viewType");
  
   //  Build query params dynamically
  let url = `/ads_analyses?start_date=${formattedStart}&end_date=${formattedEnd}&category_ids=${categoryIdsStr}&tab=${selectedTab}&parent_product_id=${parentProductIdStr}`;

  if (viewType === "variation" || viewType === "product") {
    url += `&product_wise=${viewType}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
};

// ads_analyses record getting here
export const categoryPerformanceDashbaord = async ({ formattedEnd, formattedStart, selectedIds, selectedTab, viewType }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const response = await axiosInstance.get(`/ads_analyses/category_performance_dashbaord?start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}&tab=${selectedTab}&product_wise=${viewType || ""}`);
  return response.data;
};